module.exports = __webpack_public_path__ + "static/media/pcivil-brand.04be5171.png";